// ========================================================================
// PDP URL SYNC KILL — prevent variant-select clicks from mutating the URL
// ========================================================================
// Shopify's product form (ktjs_product_sg.min.js) calls
//     history.replaceState({path: newurl}, '', newurl)
// on every pack-size / variant change. The newurl is built from
// pathname + '?variant=X', which wipes any existing query params
// (UTMs, gclid, fbclid) and creates cosmetic URL churn.
//
// This patch detects calls matching that exact shape and silently
// no-ops them. All other replaceState calls (pjax, photoswipe, apps)
// pass through unchanged. Add to Cart still submits the correct
// variant because the form's hidden input is updated via a separate
// code path we don't touch.
(function() {
  if (typeof window === 'undefined' || !window.history || !window.history.replaceState) return;
  if (window.__hyvePatchedReplaceState) return;
  var orig = window.history.replaceState.bind(window.history);
  window.history.replaceState = function(state, title, url) {
    try {
      if (state && typeof state === 'object' && state.path && /[?&]variant=/.test(state.path)) {
        return;
      }
    } catch (e) {}
    return orig(state, title, url);
  };
  window.__hyvePatchedReplaceState = true;
})();
// ========================================================================
// DIRECT-TO-CHECKOUT ENFORCER — beat Qikify on the PDP Try HYVE Today CTA
// ========================================================================
// Qikify Slide Cart hijacks all form submissions to /cart/add so it can
// open its drawer after add-to-cart. That overrides the intended direct
// behavior of the PDP "Try HYVE Today" button (which has
// data-direct-checkout="true" + a return_to=/checkout hidden input).
//
// We attach a CAPTURE-phase submit listener at document level. Capture
// phase runs before bubble-phase handlers, so we intercept before any
// third-party script can hijack. On forms whose submitter has
// data-direct-checkout="true", we stopImmediatePropagation to block
// Qikify's handler, do a clean add-to-cart via fetch, then navigate
// directly to /checkout. The cart-icon slide-drawer is unaffected —
// it's a separate flow triggered by clicking the header cart icon.
(function() {
  if (window.__hyveDirectCheckoutPatch) return;
  document.addEventListener('submit', function(e) {
    var submitter = e.submitter;
    if (!submitter || submitter.getAttribute('data-direct-checkout') !== 'true') return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var formData = new FormData(e.target);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).then(function() {
      window.location.href = '/checkout';
    }).catch(function() {
      window.location.href = '/checkout';
    });
  }, true); // capture=true is essential — must run before Qikify
  window.__hyveDirectCheckoutPatch = true;
})();
// ========================================================================
// AUTO-OPEN SLIDE CART — when user arrives with ?open_cart=1 flag
// ========================================================================
// The /cart page now redirects here with this flag. We wait for Qikify
// to finish loading, programmatically click the cart icon (which Qikify
// has bound to open its slide drawer), then strip the flag from the URL
// so a page refresh doesn't re-open the drawer.
(function() {
  if (!/[?&]open_cart=1\b/.test(window.location.search)) return;
  var opened = false;
  var attempts = 0;
  var timer = setInterval(function() {
    attempts++;
    if (opened || attempts > 30) { clearInterval(timer); return; }
    if (!window.QIKIFY_STICKYCART_V2_SC_LOADED) return;
    var icon = document.querySelector('.mini-cart a.icon-link, a[href="/cart"]');
    if (!icon) return;
    opened = true;
    icon.click();
    try {
      var s = window.location.search.replace(/[?&]open_cart=1\b/, '');
      if (s && s[0] === '&') s = '?' + s.slice(1);
      history.replaceState(null, '', window.location.pathname + s + window.location.hash);
    } catch (e) {}
  }, 250);
})();
// ========================================================================
// CART PAGE REMOVE BUTTON FIX
// ========================================================================
// The cart-template.liquid Remove link calls Shopify.KT_removeItem(variantId),
// a Molla-era helper that was removed when we cleaned up the theme. Buttons
// still render but clicking them does nothing. We polyfill the function to
// hit Shopify's native /cart/change.js endpoint with quantity: 0, then reload
// so the page re-renders without the removed line. Minimal fix — no template
// edits required.
(function() {
  window.Shopify = window.Shopify || {};
  if (typeof window.Shopify.KT_removeItem === 'function') return;
  window.Shopify.KT_removeItem = function(variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    }).then(function() {
      window.location.reload();
    }).catch(function() {
      window.location.reload();
    });
  };
})();
// ========================================================================
// HEADER CART COUNT SYNC
// ========================================================================
// The header cart count is rendered server-side via {{ cart.item_count }}
// on page load. When items change via AJAX (Qikify add, direct-checkout
// polyfill, remove-button polyfill), the header stays stale until a full
// page reload. We wrap fetch() to detect Shopify cart mutation endpoints,
// then refetch /cart.js and write the new count into every .cartCount
// element in the DOM.
(function() {
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var n = cart.item_count;
        document.querySelectorAll('.cartCount').forEach(function(el) {
          el.textContent = el.classList.contains('count-mobile') ? String(n) : ' (' + n + ') ';
        });
      })
      .catch(function(){});
  }
  var origFetch = window.fetch;
  window.fetch = function(url, opts) {
    var p = origFetch.apply(this, arguments);
    var u = typeof url === 'string' ? url : (url && url.url);
    if (u && /\/cart\/(add|change|update|clear)/.test(u)) {
      p.then(refreshCartCount).catch(function(){});
    }
    return p;
  };
  window.addEventListener('pageshow', function() {
    refreshCartCount();
  });
})();
jQuery(document).ready(function(){
  jQuery('.unique-Ing-slide').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
       {
        breakpoint: 1171,
        settings: {
            dots: true,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1
        }
       },{
          breakpoint: 1050,
          settings: {
              dots: true,
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1
          }
      },{
      breakpoint: 600,
      settings: {
          dots: true,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
  }]
});

  jQuery('.st-testimonial-slide').slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
       {
        breakpoint: 1171,
        settings: {
            dots: false,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1
        }
       },{
          breakpoint: 1050,
          settings: {
              dots: false,
              arrows: true,
              slidesToShow: 2,
              slidesToScroll: 1
          }
      },{
          breakpoint: 800,
          settings: {
              dots: false,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },{
      breakpoint: 600,
      settings: {
          dots: false,
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1
      }
  }]
});


  jQuery('.hero-slide-box').slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      pauseOnHover: false,
     autoplaySpeed: 30000, // 30 seconds (30000 milliseconds)
      speed: 3000,
      responsive: [
       {
        breakpoint: 1171,
        settings: {
              dots: false,
              arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
        }
       },{
          breakpoint: 1050,
          settings: {
               dots: false,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
          }
      },{
      breakpoint: 600,
      settings: {
          dots: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
  }]
});


   jQuery('.functional-honey-slide').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 3000,
        slidesToScroll: 1,

        responsive: [{
            breakpoint: 1250,
            settings: {
                dots: false,
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, 

        {
            breakpoint: 900,
            settings: {
                dots: false,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1
            }

        }, 

        {
            breakpoint: 850,
            settings: {
                dots: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }

        }, 

        {
            breakpoint: 481,
            settings: {
               dots: false,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }); 


       jQuery('.st-category .mobile-view-slide').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 3000,
        slidesToScroll: 1,

        responsive: [{
            breakpoint: 1250,
            settings: {
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, 

        {
          breakpoint: 900,
          settings: {
              dots: false,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }, 

        {
          breakpoint: 850,
          settings: {
              dots: false,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }, 

        {
          breakpoint: 481,
          settings: {
             dots: false,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }]
    }); 


    // Initialize Slick Slider (hidden by default)
    $(".slick-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
    });

    // Show the hidden slider on thumbnail click
    $(".thumbnail").on("click", function () {
        const index = $(this).data("index") - 1; // Slick uses 0-based indexing

        // Show the hidden slider
        $("#hidden-slider").removeClass("hidden");

        // Navigate to the clicked slide
        $(".slick-slider").slick("slickGoTo", index);
    });

    // Close the slider
    $("#close-slider").on("click", function () {
        $("#hidden-slider").addClass("hidden");
    });

    // Close the slider when clicking outside the image or pressing Esc
    $("#hidden-slider").on("click", function (e) {
        if ($(e.target).closest(".slider-content").length === 0) {
            $(this).addClass("hidden");
        }
    });

    $(document).on("keydown", function (e) {
        if (e.key === "Escape") {
            $("#hidden-slider").addClass("hidden");
        }
    });



  
});

jQuery(".faq-item").click(function() {
jQuery(this).find(".faq-answer").slideToggle(300);
jQuery(".faq-item").not(this).find(".faq-answer").slideUp(300);
});

jQuery('.faq-list .accordion-item').click(function(){
if( jQuery(this).hasClass('active-drop') ) {
    jQuery('.faq-list .accordion-item').removeClass('active-drop');
} else {
    jQuery('.faq-list .accordion-item').removeClass('active-drop');
    jQuery(this).addClass('active-drop');
}
});  

jQuery(document).ready(function(){
  jQuery('.menu-widget .minus').hide();
  jQuery('.menu-widget .footer-title').click(function() {

      var currentWidgetSpace = jQuery(this).siblings('.widget-space');
      var currentMenuWidget = jQuery(this).parent('.menu-widget');

      currentWidgetSpace.slideToggle(300);

      jQuery(this).find('.plus').toggle(); 
      jQuery(this).find('.minus').toggle(); 

      currentMenuWidget.toggleClass('active');
  });
});


jQuery(document).ready(function() {
  // Initially hide the mobile menu
  jQuery('.mobile-menu-sec').hide();

  // When the #menuToggle is clicked
  jQuery('#menuToggle').on('click', function() {
      // Toggle the visibility of .mobile-menu-sec with slideToggle
      jQuery('.mobile-menu-sec').slideToggle(300);

      // Toggle the 'open' class on #menuToggle
      jQuery(this).toggleClass('open');

      // If the menu is open, show the overlay, otherwise hide it
      if (jQuery(this).hasClass('open')) {
          jQuery('.overlay').fadeIn(300);  // Show the overlay
           jQuery('body').addClass('active-nav'); 
      } else {
          jQuery('.overlay').fadeOut(300); // Hide the overlay
          jQuery('body').removeClass('active-nav');
      }
  });
});


jQuery('#close_divs').on('click', function(){
  jQuery('#menuToggle').removeClass('open');
}); 



$("form.product-form").each( function () {
  $(this).bind("submit",function(e){
    e.preventDefault();
    var formID = $(this).attr("id");
    $.ajax({
      type: 'post',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function(resp) {
        window.location.href = '/checkout';
      },
      error: function(error) {
      }
    });
    return false;
  });
});

jQuery(".nws-atc-btn-frm").each(function () {
  jQuery(this).bind("submit", function (e) {
      e.preventDefault();
      var formID = jQuery(this).attr("id");
      jQuery.ajax({
          type: 'post',
          url: '/cart/add.js',
          data: jQuery(this).serialize(),
          dataType: 'json',
          success: function (resp) {
    window.location.href = '/checkout';
},
  error: function (xhr) {
    if (xhr.responseJSON && xhr.responseJSON.message) {
        // Replace specific server message with a custom one
        if (xhr.responseJSON.message.includes("can't add more")) {
            alert("Unfortunately, this product is no longer available. Please check back soon or explore other options!");
        } else {
            // Display other error messages from the server
            alert(xhr.responseJSON.message);
        }
    } else {
        // Fallback error message
        alert("An error occurred while adding the product to the cart. Please try again.");
    }
    console.error("Error response:", xhr);
}
      });
      return false;
  });
});



jQuery('.big_slide').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  autoplay: false,
  touchMove: true,
  swipeToSlide: true,
  draggable: true,
  swipe: true,
  touchThreshold: 10,
  focusOnSelect: false,
  fade: false,
  asNavFor: '.min_slide'
});
jQuery('.min_slide').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.big_slide',
  arrows: false,
  autoplay: false,
  touchMove: true,
  dots: false,
  focusOnSelect: true,

  responsive: [{
    breakpoint: 1281,
    settings: {
        slidesToShow: 4,
        slidesToScroll: 1
    }
}, {
    breakpoint: 835,
    settings: {
        slidesToShow: 4,
        slidesToScroll: 1
    }
},

{
    breakpoint: 768,
    settings: {
        slidesToShow: 3,
        slidesToScroll: 1
    }
},
{
    breakpoint: 481,
    settings: {
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1
    }
},
{
    breakpoint: 415,
    settings: {
        dots: false,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1
    }
}]  
});




document.addEventListener("DOMContentLoaded", function () {
    // Update hidden input dynamically if required
    document.querySelectorAll(".nws-atc-btn-frm").forEach(function (form) {
        form.addEventListener("submit", function (e) {
            const variantIdInput = form.querySelector('input[name="id"]');
            if (!variantIdInput || !variantIdInput.value) {
                alert("Variant ID is missing. Please refresh the page.");
                e.preventDefault(); // Prevent form submission
            }
        });
    });
});
  
    console.log("Selected Variant ID: {{ pdp.selected_variant.id }}");
    console.log("First Variant ID: {{ pdp.variants.first.id }}");


   $(document).ready(function() {
  function updateSelectedVariants() {
    var selectedOptions = []; // Array to store selected options
    $(".nws-variant-selection input[type='radio']:checked").each(function() {
      selectedOptions.push($(this).val().toLowerCase()); // Push the selected option value to the array
    });
    var dd = selectedOptions.join(''); // Concatenate selected options
    var id = $('input[name="'+dd+'"]').val(); // Get the corresponding variant ID
    $('input.product-variant-id').val(id); 

    var selectedColor = selectedOptions[0] || ''; // Get the selected color
    $("#selected-color").text(selectedColor);

    console.log("Selected options:", selectedOptions);
    console.log("Selected variant ID:", id);
  }

  // Ensure the first two variants are selected and add a specific class on page load
  function initializeSelection() {
    var $colorVariants = $(".color-variants input[type='radio']");
    var $sizeVariants = $(".size-variants input[type='radio']");
    
    if ($colorVariants.length > 0) {
      $colorVariants.eq(0).prop('checked', true).closest('fieldset').addClass('selected-variant').find('label').addClass('selected-variant-label'); // Check and add class to the fieldset and label of the first color variant
    }

    if ($sizeVariants.length > 0) {
      $sizeVariants.eq(0).prop('checked', true).closest('fieldset').addClass('selected-variant').find('label').addClass('selected-variant-label'); // Check and add class to the fieldset and label of the first size variant
    }

    updateSelectedVariants();
  }

  // Bind updateSelectedVariants function to change event of radio buttons
  $(".nws-variant-selection input[type='radio']").change(function() {
    $(".nws-variant-selection fieldset").removeClass('selected-variant').find('label').removeClass('selected-variant-label'); // Remove class from all fieldsets and labels
    $(this).closest('fieldset').addClass('selected-variant').find('label').addClass('selected-variant-label'); // Add class to the fieldset and label of the selected radio
    updateSelectedVariants();
  });

  // Call initializeSelection initially to set initial variant selections
  initializeSelection(); 
});
  

jQuery(document).ready(function () {

  // Newsletter form safety patch
  // If any script tries to submit to /subscribe and fails, we force Shopify native newsletter submit
  jQuery(document).on("submit", ".st-newsletter form, form.omnisend-subscribe-form", function (e) {

    var $form = jQuery(this);
    var action = ($form.attr("action") || "").toLowerCase();

    // Only handle /subscribe flow
    if (!action.includes("/subscribe")) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var email = $form.find('input[type="email"]').val();
    if (!email) return;

    // Build Shopify native form submit
    var $native = jQuery('<form method="post" action="/contact#contact_form"></form>');
    $native.append('<input type="hidden" name="form_type" value="customer">');
    $native.append('<input type="hidden" name="utf8" value="✓">');
    $native.append('<input type="hidden" name="contact[tags]" value="newsletter">');
    $native.append('<input type="hidden" name="contact[email]" value="' + email + '">');

    jQuery("body").append($native);
    $native.trigger("submit");
  });

});
// === HYVE: Full-card click on subscribe + force visual state sync ===
// Fixes two issues:
//   1. Subscribe card radio only covers top 18px — make full card clickable
//   2. Dot/pill visuals don't reflect radio state after click — force sync
(function() {

  // Sync Appstle subscribe/one-time dot visuals to match radio.checked
  function syncAppstleDots() {
    var radios = document.querySelectorAll('#appstle_subscription_widget0 input[type="radio"]');
    radios.forEach(function(radio) {
      var wrap = radio.closest('.appstle_subscription_wrapper_option, .appstle_one_time_details_wrapper');
      if (!wrap) return;
      var dot = wrap.querySelector('.appstle_dot');
      if (!dot) return;
      dot.style.transform = radio.checked ? 'scale(1)' : 'scale(0)';
    });
  }

  // Sync variant pack pills (15/30/45) to match radio.checked
  function syncVariantPills() {
    var radios = document.querySelectorAll('.nws-variant-selection input[type="radio"]');
    radios.forEach(function(radio) {
      var pill = radio.parentElement && radio.parentElement.querySelector('.size-variant');
      if (!pill) return;
            if (radio.checked) {
        pill.style.setProperty('background-color', 'transparent', 'important');
        pill.style.setProperty('border-color', 'transparent', 'important');
      } else {
        pill.style.setProperty('background-color', 'transparent', 'important');
        pill.style.setProperty('border-color', 'transparent', 'important');
      }
    });
  }

  function syncAll() { syncAppstleDots(); syncVariantPills(); }

  // Make the entire subscribe card clickable (radio only covers top 18px natively)
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.appstle_subscription_wrapper_option');
    if (!card) return;
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' ||
        e.target.tagName === 'OPTION' || e.target.tagName === 'A') return;
    if (e.target.closest('label, input, select, a, .appstle_subscription_radio_wrapper')) return;
    var radio = card.querySelector('input[type="radio"]');
    if (radio && !radio.checked) {
      var label = card.querySelector('label.appstle_radio_label');
      if (label) label.click(); else radio.click();
    }
  }, false);

  // After any click inside the widget areas, forcibly sync visual state
  document.addEventListener('click', function(e) {
    if (e.target.closest('#appstle_subscription_widget0, .nws-variant-selection')) {
      setTimeout(syncAll, 30);
      setTimeout(syncAll, 200);
    }
  }, false);

  // Also catch change events (Appstle fires these on selection)
  document.addEventListener('change', function(e) {
    if (e.target.closest('#appstle_subscription_widget0, .nws-variant-selection')) {
      syncAll();
    }
  }, false);

  // Initial sync on load
  function init() { setTimeout(syncAll, 400); setTimeout(syncAll, 1500); }
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);

})();